/**
 * No figurará en el balance, en el listado de mercado (stable/no-stable), y se ignorarán los depósitos
 */
export const hiddenCoins = ['WLD', 'USDCCL', 'XO'];
